import Point from '../../models/point.js';
import { GetWapiCoordinateOrder, WapiCoordinateOrder } from '../../constants/index.js'

export function wapiReanalysisPointsForAreaToPoints(wapiReanalysisPointsForArea, coordinateOrder = [1, 0]) {
  const wapiCoordinateOrder = GetWapiCoordinateOrder(coordinateOrder);
  const result = wapiReanalysisPointsForArea.points.map(x => {
    const point = new Point();
    point.id = x.number;
    if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
      point.latitude = x.location.y;
      point.longitude = x.location.x;
    } else {
      point.latitude = x.location.x;
      point.longitude = x.location.y;
    }
    return point;
  });

  return result;
}

export function wapiPointsToPoints(wapiPoints, coordinateOrder = [1, 0]) {
  const wapiCoordinateOrder = GetWapiCoordinateOrder(coordinateOrder);

  const result = wapiPoints.map(x => {
    const point = new Point();
    point.id = x.number;
    if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
      point.latitude = x.location.y;
      point.longitude = x.location.x;
    } else {
      point.latitude = x.location.x;
      point.longitude = x.location.y;
    }

    return point;
  });

  return result;
}

